[
  {
    "id": "c9d0e1f2-a3b4-4c5d-6e7f-8a9b0c1d2e3f",
    "gtin": "01000019",
    "action": "REFILL",
    "stockLevel": "NO_STOCK",
    "shelfId": "AQ5L",
    "isNew": false,
    "status": "OPEN"
  },
  {
    "id": "d0e1f2a3-b4c5-4d6e-7f8a-9b0c1d2e3f4a",
    "gtin": "01000022",
    "action": "REFILL",
    "stockLevel": "NO_STOCK",
    "shelfId": "JZYK",
    "isNew": false,
    "status": "COMPLETED"
  },
  {
    "id": "e1f2a3b4-c5d6-4e7f-8a9b-0c1d2e3f4a5b",
    "gtin": "01000025",
    "action": "REFILL",
    "stockLevel": "NO_STOCK",
    "shelfId": "PKZ7",
    "isNew": true,
    "status": "OPEN"
  },
  {
    "id": "f2a3b4c5-d6e7-4f8a-9b0c-1d2e3f4a5b6c",
    "gtin": "01000028",
    "action": "REFILL",
    "stockLevel": "NO_STOCK",
    "shelfId": "3R6D",
    "isNew": true,
    "status": "OPEN"
  },
  {
    "id": "a3b4c5d6-e7f8-4a9b-0c1d-2e3f4a5b6c7d",
    "gtin": "01000031",
    "action": "REFILL",
    "stockLevel": "NO_STOCK",
    "shelfId": "QX44",
    "isNew": true,
    "status": "OPEN"
  },
  {
    "id": "b4c5d6e7-f8a9-4b0c-1d2e-3f4a5b6c7d8e",
    "gtin": "01000034",
    "action": "CHECK",
    "stockLevel": "NO_STOCK",
    "shelfId": "BY8E",
    "isNew": true,
    "status": "OPEN"
  },
  {
    "id": "c5d6e7f8-a9b0-4c1d-2e3f-4a5b6c7d8e9f",
    "gtin": "01000037",
    "action": "CHECK",
    "stockLevel": "NO_STOCK",
    "shelfId": "R1N8",
    "isNew": false,
    "status": "COMPLETED"
  },
  {
    "id": "d6e7f8a9-b0c1-4d2e-3f4a-5b6c7d8e9f0a",
    "gtin": "01000040",
    "action": "REFILL",
    "stockLevel": "NO_STOCK",
    "shelfId": "MM45",
    "isNew": true,
    "status": "OPEN"
  }
]